<!--
  StatusBar Component
  Bottom status bar of the window.
-->

<script lang="ts">
    // No props needed for now
</script>

<footer class="h-8 shrink-0 bg-statusbar-bg"></footer>
